/**
 * THÔNG TIN CÁ NHÂN — màn con của tab Cá nhân.
 *
 * Bố cục theo bản thiết kế `fe/thong-tin-ca-nhan.pdf`: ba khối — thông tin
 * xác thực, khuôn mặt, trung tâm bảo mật.
 *
 * Khối "Trung tâm bảo mật" là YÊU CẦU PHÁP LÝ, không phải tính năng thêm cho
 * vui: Nghị định 13/2023/NĐ-CP buộc phải cho chủ thể dữ liệu biết hệ thống
 * thu thập gì, mục đích gì, giữ bao lâu, và có quyền yêu cầu xoá
 * (docs/04 §4.9). Đừng gỡ khối này để trang gọn hơn.
 */

import { useNavigate } from 'react-router-dom'

import DangKyKhuonMat from '../components/DangKyKhuonMat'
import TuKiemTra from '../components/TuKiemTra'
import { layDeviceId } from '../lib/thietbi'
import { nhanVienHienTai } from '../services/auth.service'
import { Icon } from '../ui'

export default function ThongTinCaNhan() {
  const dieuHuong = useNavigate()
  const nv = nhanVienHienTai()

  return (
    <>
      <header className="dau-trang-con">
        <button type="button" className="nut-tron-nho" aria-label="Quay lại"
                onClick={() => dieuHuong('/ca-nhan')}>
          <Icon ten="trai" size={22} />
        </button>
        <h1>Thông tin cá nhân</h1>
        <span />
      </header>

      <div className="man-hinh" style={{ display: 'grid', gap: 'var(--k4)' }}>
        <section className="the-khoi">
          <h2 style={{ fontSize: 'var(--cy-muc)', marginBottom: 'var(--k3)' }}>
            Thông tin xác thực
          </h2>

          <div className="hang-thong-tin">
            <span className="nhan">Họ tên</span>
            <span className="gia-tri">{nv?.full_name ?? '—'}</span>
          </div>
          <div className="hang-thong-tin">
            <span className="nhan">Mã nhân viên</span>
            <span className="gia-tri">{nv?.code ?? '—'}</span>
          </div>
          <div className="hang-thong-tin">
            <span className="nhan">Múi giờ</span>
            <span className="gia-tri">{nv?.tz ?? 'Asia/Ho_Chi_Minh'}</span>
          </div>

          {/*
            Bản thiết kế có "Giới tính" và "Ngày sinh". Bảng `employees`
            (db/init/001) KHÔNG có hai cột đó, và `/auth/login` cũng không trả
            về. Hiện ô trống ở đây trông như dữ liệu của người dùng bị mất.
          */}
          <p className="ghi-chu" style={{ marginTop: 'var(--k3)' }}>
            Giới tính và ngày sinh do bộ phận nhân sự giữ, hệ thống chấm công
            không lưu — nó chỉ thu thập đúng những gì cần để chứng minh bạn có
            mặt.
          </p>

          <h3 style={{ fontSize: 'var(--cy-nho)', marginTop: 'var(--k4)' }}>
            Mã thiết bị
          </h3>
          <p className="ma-thiet-bi">{layDeviceId()}</p>

          {nv && !nv.device_matches && nv.device_bound && (
            <p className="canh-bao-nho" role="alert">
              Đây <strong>không phải</strong> điện thoại bạn đã đăng ký. Bản ghi
              chấm công sẽ chờ quản lý duyệt. Vào tab Yêu cầu → Đơn đổi điện
              thoại để xử lý.
            </p>
          )}

          <p className="ghi-chu">
            Mỗi nhân viên chỉ dùng một thiết bị. Đổi điện thoại cần quản lý
            duyệt, và sau khi đổi sẽ khoá 90 ngày.
          </p>
        </section>

        {/* Bắt buộc cho chấm công tại công trình (docs/07). Đồng ý trước, đăng ký sau. */}
        <section className="the-khoi">
          <h2 style={{ fontSize: 'var(--cy-muc)', marginBottom: 'var(--k3)' }}>
            Khuôn mặt
          </h2>
          <DangKyKhuonMat />
        </section>

        {/* Chẩn đoán gộp cả phía trình duyệt lẫn phía máy chủ — thứ cần xem
            KHI CÓ VẤN ĐỀ, nên để dưới phần khai báo. */}
        <section className="the-khoi">
          <h2 style={{ fontSize: 'var(--cy-muc)', marginBottom: 'var(--k3)' }}>
            Kiểm tra điều kiện chấm công
          </h2>
          <TuKiemTra />
        </section>

        <section className="the-khoi">
          <h2 style={{ fontSize: 'var(--cy-muc)', marginBottom: 'var(--k3)' }}>
            Trung tâm bảo mật
          </h2>
          <p style={{ marginTop: 0, fontSize: 'var(--cy-nho)' }}>
            Hệ thống chỉ thu thập vị trí <strong>tại đúng thời điểm bạn bấm
            chấm công</strong>, không theo dõi liên tục. Ảnh xác minh được xoá
            dữ liệu máy ảnh và lưu tối đa 24 tháng.
          </p>
          <p style={{ marginBottom: 0, fontSize: 'var(--cy-nho)' }}>
            Bạn có quyền xem toàn bộ dữ liệu của mình ở tab <strong>Chọn
            tháng</strong>, rút lại đồng ý sinh trắc học bất cứ lúc nào ở khối
            Khuôn mặt phía trên, và yêu cầu xoá dữ liệu khi nghỉ việc.
          </p>
        </section>
      </div>
    </>
  )
}
